import { Spinner } from "@components/ui/spinner";
import { zodResolver } from "@hookform/resolvers/zod";
import "@assets/css/bootstrap-grid.css";
import { getInputField } from "@utils/function/index.function";
import { FormField } from "@utils/interface/form.interface";
import {
  UserForgetFormData,
  UserForgetSchema,
} from "@utils/interface/form.schema";
import { usePostData } from "@utils/query/index.query";
import React, { useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useResetPassword, useSelectionStore } from "@utils/states/index.state";
import { useNavigate } from "react-router";
import { ChevronLeft } from "lucide-react";
import { showToast, throwErrorAlert } from "@utils/helper/index.helper";
import { METHODS } from "@utils/interface/index.interface";
import { endpoint } from "@services/api.services";

const ForgetPasswordForm: React.FC = () => {
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<UserForgetFormData>({
    mode: "onChange",
    resolver: zodResolver(UserForgetSchema),
  });

  /* set default value */
  useEffect(() => {}, []);

  const { mutate, isPending } = usePostData();
  const setEmail = useResetPassword((state) => state.setEmail);
  const navigate = useNavigate();

  const handleMutate = (data: any) => {
    return {
      data,
      endpoint: endpoint["auth"]["getOtp"],
      method: METHODS.POST,
    };
  };
  const handleSuccess = async ({ data, status }: any) => {
    if (status !== 200) {
      return showToast({
        description: data[0],
        type: "error",
        title: "Error",
      });
    }
    showToast({
      description: "OTP Sent Successfully",
      type: "success",
      title: "Success",
    });
    navigate("/reset-verify-otp?email=" + data.email);
  };
  const { setIsFormPending } = useSelectionStore();
  const handleError = async (error: any) => {
    console.log(error, "error00");
    if (error?.data?.status == 413) {
      showToast({
        description: "File Size Too Large",
        type: "error",
        title: "Error",
      });
    }
    setIsFormPending(false);
    const errorMessage = error.data.response.data;
    console.log(errorMessage, "Error Message");
    throwErrorAlert(error.data.response.data);
  };
  const onSubmit: SubmitHandler<UserForgetFormData> = (data) => {
    setEmail(data.email);
    mutate(handleMutate(data), {
      onSuccess: ({ data, status }) => handleSuccess({ data, status }),
      onError: (data) => handleError({ data }),
    });

    //Add Mutation Data
  };

  const formSchema: FormField[] = [
    {
      name: "email",
      label: "Email Address",
      colSpan: 12,
      type: "text",
      placeholder: "xyz@vrittechnologies.com",
      validation: { required: "Name is required" },
      control: control,
      setValue: setValue,
      errors,
      className: `mb-[20px] min-w-full w-full`,
      visable: true,
    },
    {
      type: "submit",
      value: "Next",
      className: "w-full h-[47px] mt-[32px]",
      colSpan: 12,
      variant: "default",
      endIcon: isPending ? <Spinner /> : null,
      disabled: isPending ? true : false,
      visable: true,
    },
    {
      type: "button",
      value: "Back to login ",
      className: "w-full h-[47px] mt-[4px] text-[#1DA077]",
      startIcon: <ChevronLeft />,
      colSpan: 12,
      onClick: () => navigate("/login"),
      variant: "ghost",
      disabled: isPending ? true : false,
      visable: true,
    },
  ];

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="row w-[424px] max-md:w-full max-md:p-4"
      >
        {formSchema.map(
          (field, index) =>
            (field.visable || field.visable == undefined) && (
              <div
                key={index}
                className={`col-lg-${field.colSpan} col-12 lg:px-[12px] px-[8px]`}
              >
                {getInputField({ ...field })}
              </div>
            )
        )}
      </form>
    </>
  );
};

export default ForgetPasswordForm;
